
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.33 2.22L21.33 9.22C21.4535 9.36781 21.5145 9.55794 21.5 9.75V15.11C21.5003 17.7007 19.4205 19.8117 16.83 19.85C16.1677 21.4836 14.5925 22.5626 12.83 22.59H7.38C4.96489 22.59 3.00551 20.6351 3 18.22V9.14C3.0055 6.72327 4.96327 4.7655 7.38 4.76H7.81C8.57931 3.08662 10.2483 2.01037 12.09 2H13.8C13.9988 2.00018 14.1895 2.07931 14.33 2.22ZM18.96 8.93L14.69 4.66V7.76C14.6954 8.40391 15.2161 8.92457 15.86 8.93H18.96ZM12.83 21.09H7.38C5.79332 21.09 4.50551 19.8067 4.5 18.22V9.14C4.5 7.54942 5.78942 6.26 7.38 6.26V15.11C7.38 17.7334 9.50665 19.86 12.13 19.86H15.23C14.6832 20.6424 13.7844 21.103 12.83 21.09ZM12.09 18.36H16.79C18.5849 18.36 20.04 16.9049 20.04 15.11V10.58H15.81C14.2548 10.5745 12.9955 9.31517 12.99 7.76V3.5H12.09C11.2237 3.50264 10.394 3.85002 9.7842 4.46543C9.17442 5.08084 8.83468 5.91366 8.84 6.78V15.11C8.84549 16.9026 10.2974 18.3545 12.09 18.36Z","fill":"currentColor"}})])
          )
        }
      }
    